import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import ChipUI from '@mui/material/Chip';
import ListItemSecondaryActionUI from '@mui/material/ListItemSecondaryAction';
import PropTypes from 'prop-types';
import React from 'react';
import {addQueryParams} from '@apps-common/js-client/api/util';
import {alpha, styled} from '@mui/material/styles';
import {useAuth} from '@apps-common/auth-react';

export const LIST_ITEM_THUMBNAIL_SIZE = 64;

export const ListItemSecondaryAction = styled(ListItemSecondaryActionUI)(
  ({theme}) => ({
    right: theme.spacing(0.5),
  })
);

// TODO: Break out into mui-components lib
export const Chip = styled(ChipUI)(({theme}) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.grey[900], 0.08),
  '& .MuiChip-outlined': {
    borderColor: theme.palette.grey[300],
    backgroundColor: 'inherit',
  },
  '& .MuiChip-label': {
    paddingLeft: ({label}) => (label === '' ? 0 : theme.spacing(1)),
  },
  '& svg': {fill: theme.palette.text.secondary},
}));
Chip.defaultProps = {
  size: 'small',
};

export const Thumbnail = ({src, ...props}) => {
  const auth = useAuth();

  return (
    <Box flexShrink={0} mr={1} {...props}>
      <CardMedia
        component="img"
        src={src && addQueryParams(src, {token: auth.user?.accessToken})}
      />
    </Box>
  );
};

Thumbnail.propTypes = {
  src: PropTypes.string,
};

Thumbnail.defaultProps = {
  width: LIST_ITEM_THUMBNAIL_SIZE,
  height: LIST_ITEM_THUMBNAIL_SIZE,
};

const ListContainer = styled('div')({
  flexGrow: 1,
  overflow: 'auto',
  height: '100%',
  width: '100%',
  backgroundColor: 'white',
});

export default ListContainer;
